import { REFLEX_SCAN_SCHEME } from './content-scanner-dispatch';

/**
 * react-markdown's default urlTransform strips any URL whose scheme isn't in
 * its safelist (http/https/mailto/...). Our internal {@link REFLEX_SCAN_SCHEME}
 * never reaches the network, so we let it through verbatim and fall back to the
 * same safelist for everything else.
 */
export function passthroughReflexScanUrlTransform(url: string): string {
  if (url.startsWith(REFLEX_SCAN_SCHEME)) return url;
  // Mirror react-markdown's defaultUrlTransform safelist.
  const safe = /^(https?|mailto|tel|irc|ircs|xmpp):/i;
  if (safe.test(url)) return url;
  if (/^[/#?]/.test(url)) return url; // relative
  // For anything else, return empty string (matches default behavior).
  if (/^[a-z][a-z0-9+\-.]*:/i.test(url)) return '';
  return url;
}
